<template>
    <v-app>
        <router-view />
        <v-snackbar v-model="showSnackbar">
            {{ snackbarMessage }}
            <v-btn color="primary" @click="showSnackbar=false" flat>OK</v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
    import { events } from './main';
    export default {
        name: 'App',
        data() {
            return {
                snackbarMessage: '',
                showSnackbar: false,
            }
        },
        methods: {
            snackbar(message){
                this.snackbarMessage = message;
                this.showSnackbar = true;
            }
        },
        mounted () {
            events.$on('snackbar', (message) => {
              this.snackbar(message)
            });
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,700|Open+Sans');

    /************* General Styles *************/

    /* font for titles and headers */
    h1, h2, h3, h4, h5, h6, th {
        font-family: Roboto;
    }
    h3 { font-size: 36px; }

    /* general font for every text */
    #app {
        background-color: var(--v-appBackground-base);
        font-family: Roboto;
        color: var(--v-textColor-base);
    }
    .v-input.customInput.pa-0.v-text-field  /deep/  .v-input__slot {
        padding-left: 0px !important;
        padding-right: 0px !important;
        min-height: 35px!important;
        font-size: 14px;
    }
    .v-input.customInput.pa-0.theme--light.v-text-field:not(.v-textarea):not(.v-select):not(.no-right-padding) > .v-input__control > .v-input__slot{
        padding-left: 0px !important;
        padding-right: 0px !important;
        background-color: #ffffff;
        border-radius: 0px !important;
    }
    .v-input input[type="number"] {
        margin-right: 18px;
    }

    /* Input Labels */
    .v-input .v-label {
        color: black;
    }

    /* Input Labels */

    .lance.v-text-field:not(.v-text-field--solo) {
        margin-top: -12px;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-text-field__details {
        padding-left: 12px;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot::after,
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot::before {
        content: none;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot {
        background: white;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot .v-label  {
        top: 15px;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot .v-label.v-label--active {
        top: 20px;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot > .v-select__slot  {
        height: 100%;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot .v-input__append-inner {
        margin-top: 0;
    }
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot > .v-text-field__slot > input,
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot > .v-text-field__slot > .v-text-field__prefix,
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot > .v-text-field__slot > textarea,
    .lance.v-text-field:not(.v-text-field--solo) > .v-input__control > .v-input__slot .v-select__selections  {
        margin-top: 15px;
    }

    .v-select.v-text-field .v-label {
        max-width: calc(90% - 40px);
    }

    .v-text-field > .v-input__control > .v-input__slot,
    .v-text-field.v-text-field--solo > .v-input__control > .v-input__slot {
        min-height: 50px;
        border-radius: 10px !important;
        padding-left: 50px !important;
        padding-right: 0 !important;
    }
    .v-text-field.v-input--is-disabled .v-input__slot {
        background-color: rgba(0,0,0,0.12)!important;
        box-shadow: none !important;
    }
    .v-text-field.v-input--is-disabled:not(.v-input--is-dirty) .v-input__slot *,
    .v-text-field.v-input--is-disabled .v-input__slot input::placeholder {
        color: rgba(0,0,0,0.19);
    }

    /* General tab styles */
    .v-tabs .v-tabs__wrapper {
        margin: -10px;
        padding: 10px;
        padding-bottom: 0;
        margin-bottom: 0;
    }
    .v-tabs .v-tabs__bar {
        background: transparent;
        border-bottom: 3px solid var(--v-primary-base);
    }
    .v-tabs .v-tabs__item {
        text-transform: none;
        background-color: white;
        padding-right: 50px;
        padding-left: 50px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12) !important;
    }
    .v-tabs .v-tabs__item.v-tabs__item--active {
        color: white;
        background: var(--v-primary-base);
        z-index: 1;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    table > tbody > tr > td > i.v-icon.v-icon--link {
        margin: 0px 10px;
    }

    .many-to-one-grid{
        z-index: 1;
    }

    .many-to-one-input-container{
        display: flex; 
        align-items: center;
    }

    .dialog-input input {
        cursor: pointer;
    }

    .toolbar-form>div {
        align-items: flex-end;
    }

    .toolbar-form>div>div,
    .toolbar-form>div>button {
        margin-bottom: 13px;
    }

    .workflow-buttons-group {
        border-radius: 5px;
        padding: 5px;
        margin-left: 6px;
        display: inline-block;
        margin-left: auto;
        margin-right: 0px;
        display: block;
    }

    .workflow-buttons-group {
        border-radius: 5px;
        padding: 5px;
        margin-left: 6px;
    }

    .workflow-state-form {
        text-align: right;
    }

    .workflow-state-form>div {
        width: 20%;
        display: inline-flex;
        min-width: 200px;
    }
    /************* List component general styles *************/
    .list-title {
        margin-bottom: 30px;
    }
    
    .search-bar {
        margin-bottom: 20px;
    }

    /* Buttons */
    .search-bar .flex > button.v-btn:not(.v-btn--floating), .search-bar .flex > a.v-btn:not(.v-btn--floating){
        margin: 0;
        width: 100% !important;
        height: 35px !important;
        text-transform: none;
        border-radius: 10px;
        color: white;
        font-size: 16px;
    }

    .search-bar .v-select .v-input__append-inner, .search-bar .v-text-field .v-input__append-inner {
        height: 50px;
        width: 70px;
        border-top-right-radius: 100px;
        border-bottom-right-radius: 100px;
    }

    .search-bar .v-select.v-input--is-focused .v-input__append-inner, .search-bar .v-text-field.v-input--is-focused .v-input__append-inner {
        background: white;
    }

    .search-bar .v-select.v-input--is-disabled .v-input__append-inner, .search-bar .v-text-field.v-input--is-disabled .v-input__append-inner {
        background: lightgray;
    }

    .search-bar .v-select .v-input__append-inner > .v-input__icon--append, .search-bar .v-text-field .v-input__append-inner > .v-input__icon--append {
        align-self: center;
        padding-right: 8px;
    }

    .search-bar .v-select .v-input__append-inner > .v-input__icon--append .v-icon, .search-bar .v-text-field .v-input__append-inner > .v-input__icon--append .v-icon {
        color: var(--v-textColor-base) !important;
        font-size: 30px;
    }

    .table-list {
        background: white;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 20px;
    }
    .table-list table.v-table, .table-list .v-datatable.v-table {
        border-radius: 20px;
    }
    .table-list .v-datatable.v-table .v-datatable__actions {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;

    }
    .table-list table.v-table thead tr th {
        font-size: 16px;
        font-weight: bold;
        padding-left: 36px;
        padding-right: 36px;
    }
    .table-list table.v-table tbody tr td {
        font-size: 14px;
        padding-left: 36px;
        padding-right: 36px;
    }
    .table-list table.v-table thead tr:first-child {
        border-bottom-width: 2px !important;
    }
    .table-list table.v-table tbody tr {
        border-bottom-width: 0.5px !important;
    }
    .table-list table.v-table tr {
        height: 48px;
    }
    .table-list table.v-table .v-progress-linear {
        height: 4px !important;
    }

    .table-list {
        background: white;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 20px;
    }
    .table-list table.v-table, .table-list .v-datatable.v-table {
        border-radius: 20px;
    }
    .table-list .v-datatable.v-table .v-datatable__actions {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;

    }
    .table-list table.v-table thead tr th {
        font-size: 16px;
        font-weight: bold;
        padding-left: 36px;
        padding-right: 36px;
    }
    .table-list table.v-table tbody tr td {
        font-size: 14px;
        padding-left: 36px;
        padding-right: 36px;
    }
    .table-list table.v-table thead tr:first-child {
        border-bottom-width: 2px !important;
    }
    .table-list table.v-table tbody tr {
        border-bottom-width: 0.5px !important;
    }
    .table-list table.v-table tr {
        height: 48px;
    }
    .table-list table.v-table .v-progress-linear {
        height: 4px !important;
    }

    .table-catalog {
        background: white;
        padding: 50px;
        padding-bottom: 10px;
        border-radius: 18px;
    }
    
    .table-catalog table.v-table thead tr th {
        font-size: 20px;
        font-weight: bold;
    }
    .table-catalog table.v-table tbody tr td {
        font-size: 16px;
    }

    .table-catalog table.v-table tr {
        border-bottom-width: 0 !important;
        height: 48px;
    }
    .table-catalog table.v-table thead th:not(:first-child):not(:last-child),
    .table-catalog table.v-table tbody td:not(:first-child):not(:last-child) {
        border-left: solid 1px var(--v-textColor-base);
        padding-left: 80px;
    }
    .table-catalog-border-first table.v-table thead th:not(:nth-child(2)):not(:last-child),
    .table-catalog-border-first table.v-table tbody td:not(:nth-child(2)):not(:last-child) {
        border: none;
    }
    div.table-catalog > div.v-datatable.v-table > div.v-datatable__actions {
        border: none;
    }

    div.table-catalog .v-btn--floating.v-btn--small {
        height: 30px;
        width: 30px;
    }
    div.table-catalog table button.theme--dark.v-btn.v-btn--disabled[disabled] {
        background-color: #777;
    }

    /************* Form component general styles *************/

    .form-component h3.form-title {
        margin-bottom: 50px;
    }
    .form-component h3.form-title > .v-btn {
        height: 50px;
        width: 50px;
    }

    .form-component .divider {
        height: 0px;
        border-bottom: solid 1px var(--v-textColor-base);
        padding: 0 !important;
        margin: 0 8px;
        margin-top: 25px;
        margin-bottom: 40px;
    }

    .form-component .table-catalog {
        padding: 30px 50px;
        margin-bottom: 30px;
    }
    .form-component .table-catalog table.v-table thead th:not(:first-child),
    .form-component .table-catalog table.v-table tbody td:not(:first-child) {
        border-left: solid 1px var(--v-textColor-base);
        padding-left: 80px;
    }

    .form-component .v-input .v-input__append-inner {
        min-height: 50px;
        align-self: stretch;
        min-width: 50px;
        background: var(--v-primary-base);
        border-top-right-radius: 100px;
        border-bottom-right-radius: 100px;
    }

    .form-component .v-select.v-input--is-focused .v-input__append-inner {
        background: var(--v-primary-darken2);
    }

    .form-component .v-input.v-input--is-disabled .v-input__append-inner {
        background: lightgray;
    }

    .form-component .v-select .v-input__append-inner > .v-input__icon--append {
        align-self: center;
        padding-right: 8px;
    }

    .form-component .v-select .v-input__append-inner > .v-input__icon--append .v-icon {
        color: white !important;
        font-size: 48px;
    }

    .form-component .flex > button.v-btn:not(.v-btn--floating) {
        margin: 0;
        width: 100% !important;
        height: 50px !important;
        text-transform: none;
        border-radius: 100px;
        color: white;
        font-size: 16px;
    }

    /*************  *************/

    .filter-button{
        margin: 20px;
        text-decoration: underline;
    }

    .filter-button i{
        font-size: 14px !important;
        color: inherit !important;
        display: inline-block;
    }

    .text.divider-container {
        display: block;
        background-color: var(--v-secondary-lighten5);
        color: var(--v-secondary-lighten1);
        max-width: max-content;
        padding: 0px 15px;
        font-size: 12px;
        align-self: baseline;
    }

    hr.divider-container {
        border-color: var(--v-secondary-lighten5) !important;
    }

    .grid-container {
        display: flex;
        justify-content:center;
        flex-direction: column;
    }

    .grid-btn {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    tr.itemToDelete{
        background-color: var(--v-warning-lighten3);
    }

    .back-icon {
        font-weight: 800;
        color: var(--v-secondary-darken4);
    }

    .form-actions-container{
        text-align: center;
    }

    .form-actions-container button{
        width: 180px !important;
        margin: 15px;
    }

    .v-input--switch:focus {
        outline-color: transparent;
    }

    button:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--floating) {
        width: 130px;
    }

    button:not(.v-btn--small):not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--floating) {
        height: 40px;
    }

    .v-input__prepend-outer {
        font-size: 14px;
        min-width: 125px;
        max-width: 125px;
        text-align: right;
        display: inline-block;
        margin-bottom: auto;
        margin-top: auto;
        -webkit-transition: all .2s ease 0s;
        -moz-transition: all .2s ease 0s;
        -o-transition: all .2s ease 0s;
        transition: all .2s ease 0s;
    }

    .v-input--checkbox {
        height: inherit;
        align-items: center;
        justify-content: flex-end;
        margin-top: unset;
        padding-top: unset;
    }

    .v-input--checkbox:focus {
        outline: none;
    }
</style>